// Models
import { RecurrenceCalculator } from "./RecurrenceCalculator";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Represents a daily recurrence pattern calculator
 * @example Every 3rd day.
 */ export class DailyRecurrenceCalculator extends RecurrenceCalculator {
    calculateOccurrencesBetween(start, end) {
        return this.getPeriodsBetween(this.offsetStart(start), end).filter(// Get only periods that fall on the interval
        (period)=>this.getDurationBetweenDateAndPatternStartDate(period) % this.interval === 0);
    }
    offsetStart(start) {
        let startOffset = Temporal.PlainDate.from(start);
        /** OPTIMIZATION BELOW: Remove all days before pattern start date. */ if (Temporal.PlainDate.compare(start, this.patternStartDate) <= 0) {
            startOffset = Temporal.PlainDate.from(this.patternStartDate);
        }
        return startOffset;
    }
    isSameOrBefore(start, end) {
        return Temporal.PlainDate.compare(start, end) <= 0;
    }
    getDurationBetweenDateAndPatternStartDate(date) {
        return date.since(this.patternStartDate, {
            largestUnit: "days"
        }).days;
    }
    constructor(schedule, patternStartDateAsInstant, occurrenceIndex){
        super(schedule, patternStartDateAsInstant, occurrenceIndex, {
            days: 1
        });
    }
}
